var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"welcome-card docs-card elevation-0"},[_c('v-card-title',[_c('v-col',[_c('v-row',{staticClass:"justify-center headline"},[_vm._v(" iAdOps ")]),_c('v-row',{staticClass:"justify-center body-2 coolgray--text"},[_vm._v(" "+_vm._s(_vm.version.split('-')[0])+" ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }